<template>
	<div class="mode" :style="{ height: `${windowHeight}px` }">
		<el-row>
			<el-col :span="7" style="color:transparent">1</el-col>
			<el-col :span="2" class="collabel"><span>商品名称：</span></el-col>
			<el-col :span="6" >
				<el-input type="text" size="mini" v-model="cname" @keyup.native="enterinput"></el-input>
				<br />
			</el-col>
			<el-col :span="2" class="submitBtn">
				<el-button type="success" size="mini" @click="GetTax">查询</el-button>
			</el-col>
		</el-row>
		<el-row style="margin-top:10px">
			<el-col :span="7" style="color:transparent">1</el-col>
			<el-col :span="2" class="collabel"><span>查询结果：</span></el-col>
			<el-col :span="6" style="text-align:left;">
				<el-input type="text" :readonly="true" v-model="taxid" size="mini"></el-input>
			</el-col>
			<el-col :span="2">
				<el-button size="mini" @click="copy" type="warning">复制</el-button>
			</el-col>
		</el-row>
		<el-row style="font-size:12pt;margin-top:10px">
			<el-col :span="7" style="color:transparent">1</el-col>
			<el-col :span="16" style="text-align:left;padding-left:20px">
				<div v-if="taxid!=''&&taxid!='无结果'">
					<span> HS名称: {{webcname}}</span>
					<span style="padding-left:10px">单位: {{unit}}</span>
					<span style="padding-left:10px">税率: {{taxrate}}</span>
				</div>
			</el-col>
		</el-row>
		 <el-divider></el-divider>
		<el-row style="margin-top:10px">
			<el-col :span="2" style="color:transparent">1</el-col>
			<el-col :span="20">
				<div>
					<iframe :src="url" ref="mobsf" frameborder="0" :style="{ height: `${windowHeight}px`,width:`100%`}"></iframe>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';	
export default {
	data() {
		return {
			windowHeight: window.innerHeight - 120,
			taxid:'',
			cname:'',
			url:'',
			divclass:'mode',
			webcname:'',
			unit:'',
			taxrate:''
		};
	},
	methods:{
		GetTax(){
			var that=this;
			if(this.cname!=''){
				this.$tool.loading('正在获取', this.divclass);
				this.$apipost.get.GetTaxid({cname:this.cname}).then(res => {
					this.$tool.loadingclose();
					//console.log('税号',res);
					if(res.state=='1'){
						if(res.info!=undefined){
							that.taxid=res.info.taxid;
							that.webcname=res.info.webcname+'('+res.info.hsname+')';
							that.unit=res.info.unit;
							that.taxrate=res.info.taxrate;
						}
					}
					else
						that.taxid='无结果';
				});
				this.url='https://www.hsbianma.com/search?keywords='+escape(this.cname)+'&filterFailureCode=true';
				this.$refs.mobsf.src=this.url;
			}
		},
		enterinput(e){
			if(e.keyCode==13){
				this.GetTax();
			}
		},
		copy() {
		  let oInput = document.createElement('input')
		  oInput.value = this.taxid;
		  document.body.appendChild(oInput)
		  oInput.select(); // 选择对象
		  document.execCommand("Copy") // 执行浏览器复制命令
		  this.$message({
		    message: '复制成功',
		    type: 'success',
			duration:1000
		  })
		  oInput.remove();
		}
	}
}
</script>

<style>
.mode{
	text-align:center;
	padding-top:2%;
}
.footerhandler{
			margin-top:20px;
		}	
</style>
